import { render, staticRenderFns } from "./QZ.vue?vue&type=template&id=a5e7797c&scoped=true&"
var script = {}
import style0 from "./QZ.vue?vue&type=style&index=0&id=a5e7797c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e7797c",
  null
  
)

export default component.exports